import styled from 'styled-components';
import Box from '@mui/material/Box';

export const Container = styled(Box)`
  display: flex;
  flex: 1;
  justify-self: flex-end;
  justify-content: flex-end;
  align-items: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    order: 3;
  }
  list-style-type: none;
  margin: 0;
`;
